import { AmenityType } from '@/shared/api/topli/TopliApi'
import { UploadPhotoFormState } from '../model/type'

export const uploadPhotoFormDefault: UploadPhotoFormState = {
  oid: 0,
  type: AmenityType.Unit,
  image: null,
}
